import {
    deleteRequest,
    putRequest,
    getRequest,
    postRequest,
 } from "../../utils/api";
 const gateway_prefix='/api/charge-gateway';
 
 export const apiList = (data) => {
    return postRequest(gateway_prefix+'/list?page=1&size=20', data)
 }
 
 export const apiUpdate = (data) => {
    return putRequest(gateway_prefix+'/update', data)
 }
 
 export const apiDelete = (id) => {
    return deleteRequest(gateway_prefix+'/delete/'+id)
 }
 export const apiGet = (id) => {
    return getRequest(gateway_prefix+'/get/'+id)
 }
 export const apiCount = (stationId) => {
   return getRequest(gateway_prefix+'/count/'+stationId)
}

 export const apiListStations = (data) => {
   return postRequest('/api/charge-station/list?page=1&size=999', data)
}

 
 